import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles((theme: any) =>
  createStyles({
    tabsParent: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '100%',
    },
    tabsContainer: {
      display: 'flex',
      padding: 4,
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: '30px',
      marginBottom: 24,
    },
    tabContent: {},
    tab: {
      cursor: 'pointer',
      padding: '12px 16px',
      borderRadius: '22px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500,
      width: '100%',
      textAlign: 'center',
      position: 'relative',
      '@media (max-width: 600px)': {
        fontSize: '12px',
        lineHeight: '18px',
      },
    },
    animatingDiv: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: 9999,
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
    },
    tabLabel: {
      position: 'relative',
      zIndex: 10,
    },
  }),
);
